import { PLANS_LIST, RAZORPAY_CREATE_ORDER, RAZORPAY_PAYMENT_SUCCESS, STRIPE_CHECKOUT, STRIPE_PAYMENT_SUCCESS } from "./types";


export const stripeCheckoutAction = (data, onSuccess, onError) => {
    return {
        type: STRIPE_CHECKOUT,
        data,
        onSuccess,
        onError,
    };
};

export const stripePaymentSuccessAction = (data, onSuccess, onError) => {
    return {
        type: STRIPE_PAYMENT_SUCCESS,
        data,
        onSuccess,
        onError,
    };
};



export const razorpayCreateOrderAction = (data, onSuccess, onError) => {
    return {
        type: RAZORPAY_CREATE_ORDER,
        data,
        onSuccess,
        onError,
    };
};

export const razorpayPaymentSuccessAction = (data, onSuccess, onError) => {
    return {
        type: RAZORPAY_PAYMENT_SUCCESS,
        data,
        onSuccess,
        onError,
    };
};



export const plansListAction = (data, onSuccess, onError) => {
    return {
        type: PLANS_LIST,
        data,
        onSuccess,
        onError,
    };
};
